import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        type: 'dark',
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 450,
            md: 600,
            lg: 900,
            xl: 1200,
        },
    },
    overrides: {
        MuiTableCell: {
            root: {
                padding: 12,
            },
        },
    },
});

export default theme;
